export default __webpack_public_path__ + "static/media/tool_facebook.9f9cfed0.png";